import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=dd660b2e&scoped=true&"
import script from "./confirmation.vue?vue&type=script&lang=js&"
export * from "./confirmation.vue?vue&type=script&lang=js&"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=dd660b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd660b2e",
  null
  
)

export default component.exports